export enum Mode {
    MONTHLY = 'monthly',
    YEARLY = 'yearly',
}
